import React, { useEffect, useState } from 'react';
import supabase from '../supabase/supabase';
import { FiTrash2, FiAlertCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function AdminCategoryList({ refreshKey }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, [refreshKey]);

  const fetchCategories = async () => {
    const { data, error: fetchError } = await supabase
      .from('categories_1715000000')
      .select('*')
      .order('name');
    
    if (fetchError) {
      setError(fetchError.message);
    } else {
      setCategories(data || []);
    }
    setLoading(false);
  };

  const handleDelete = async (id, name) => {
    if (!confirm(`Trash "${name}"? Posts will become Uncategorized.`)) return;
    
    setError(null);
    const { error: deleteError } = await supabase
      .from('categories_1715000000')
      .delete()
      .eq('id', id);

    if (deleteError) {
      setError(`Failed to delete: ${deleteError.message}`);
    } else {
      fetchCategories();
    }
  };

  if (loading) return <div className="font-bold text-retro-brown animate-pulse bg-white p-8 rounded-3xl border-4 border-retro-brown shadow-retro">Loading tags...</div>;

  return (
    <div className="bg-white p-8 rounded-3xl shadow-retro border-4 border-retro-brown">
      <h2 className="font-display text-2xl tracking-wider text-retro-brown uppercase mb-6 drop-shadow-[1px_1px_0_#F4D03F]">Active Tags</h2>
      
      {error && (
        <div className="mb-6 p-4 bg-red-100 border-4 border-retro-brown text-red-700 rounded-xl font-bold flex items-center gap-3 shadow-retro-sm">
          <SafeIcon icon={FiAlertCircle} className="text-xl" /> {error}
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {categories.map((cat) => (
          <div key={cat.id} className="flex justify-between items-center p-3 bg-retro-cream border-2 border-retro-brown rounded-xl shadow-retro-sm hover:shadow-retro hover:-translate-y-0.5 transition-all group">
            <span className="font-bold text-retro-brown truncate pr-2">{cat.name}</span>
            <button 
              onClick={() => handleDelete(cat.id, cat.name)}
              className="text-retro-brown bg-white border-2 border-retro-brown p-2 rounded-lg hover:bg-red-500 hover:text-white transition-colors flex-shrink-0"
              title="Delete Category"
            >
              <SafeIcon icon={FiTrash2} />
            </button>
          </div>
        ))}
        {categories.length === 0 && !error && (
          <p className="col-span-full text-base font-bold text-retro-brown/50 py-4 text-center border-4 border-dashed border-retro-brown/30 rounded-xl">No categories found.</p>
        )}
      </div>
    </div>
  );
}